/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
import { useSelector } from 'react-redux';
// material
import TableReportSection from "../../../../../material/tablereportsection/tablereportsection";
// styles
import injectSheet from 'react-jss';
import styles from './toparticlesreport_styles';



/* ========== ~~~~~~~~~~ COMMENTING ANALYTICS - TOP ARTICLES REPORT ~~~~~~~~~~ ========== */
const TopArticlesReport = injectSheet(styles)((props) => {

    const { data, status } = useSelector((state) => state.commenting.topArticlesByEngagement);

    const columns = [
        {
            key: 'rank',
            title: 'Rank'
        },
        {
            key: 'title',
            title: 'Title',
            url: 'pageUrl'
        },
        {
            key: 'total',
            title: 'Total',
            format: 'comma'
        },
        {
            key: 'rootComments',
            title: 'Root Comments',
            format: 'comma'
        },
        {
            key: 'replies',
            title: 'Replies',
            format: 'comma'
        },
        {
            key: 'reactions',
            title: 'Reactions',
            format: 'comma'
        }
    ];
    const handleExportDataTransform = (obj) => obj.map(row => {
        const formattedRow = {};
        columns.forEach(columnConfig => {
            formattedRow[columnConfig.key] = row[columnConfig.key];
        })
        return formattedRow;
    });

    const exportDataConfig = {
        fileName: 'top_articles_by_engagement',
        excludedColumns: ['embed_uuid', ''],
        transpiler: handleExportDataTransform
    };
    const exportAllDataConfig = {
        onClick: props.onExportAllClick
    }
    const includeTotalColumn = (data) => {
        return data.map(row => {
            return {
                ...row,
                total: (row.rootComments || 0)
                    + (row.replies || 0)
                    + (row.reactions || 0)
            }
        })
    };
    return (
        <div name={'toparticlesreport'} class={`${props.classes.toparticlesreport}`} >
            <TableReportSection
                title={'Top Articles by Engagement'}
                columns={columns}
                data={includeTotalColumn(data.slice(0, 20))}
                rowsPerPage={5}
                exportData={exportDataConfig}
                exportAll={exportAllDataConfig}
                loading={status === 'pending'}
                tooltipContent={
                    <div className={'tip-content'}>
                        <div className={'tip-title'}>
                            <h4>Top Articles by Engagement</h4>
                        </div>
                        <div className={'tip-desc'}>
                            <p>
                                A list that ranks the top 20 articles that have the most engagement over the selected timeframe.
                                Engagement is defined by summing the Root Comments, Replies, and Reactions for each article.
                                Note: the counts we show you in the table are for the time period only, not all of the engagement for the 
                                article since it was published.
                            </p>
                        </div>
                    </div>
                }
            />
        </div>
    );
});


/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default TopArticlesReport;
